export default __webpack_public_path__ + "static/media/valuation_output_plh.eefb38aa.png";